<template>
  <div class="wrapper">
    <MovingDivider id="waves" :index="0"/>

    <section id="about">
      <div class="about-wrapper">
        <h2 id="who-are-we" tabindex="-1"><a href="#who-are-we" class="header-link">Who Are We?</a></h2>
        <MarkdownRenderer class="about-us" :content="$store.state.content.intro" />
      </div>

      <InfiniteCarousel name="About Us" :images="galleryImages" :speed="0.3"/>
      <div class="section">
        <div 
          class="video-container"
          tabindex="0"
          role="region"
          aria-label="Cyclone RoboSub introduction video. Press Enter or Space to interact with the video player."
          @keydown.enter="focusVideo"
          @keydown.space.prevent="focusVideo"
        >
          <iframe 
            ref="videoIframe"
            :src="$store.state.general.introVideoURL" 
            loading="lazy" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowfullscreen
            data-cookieconsent="marketing"
            title="YouTube video player"
            tabindex="-1"
          ></iframe>
        </div>

        <div class="mission-wrapper">
          <h2 id="founding"><a href="#founding" class="header-link">Founding</a></h2>
          <MarkdownRenderer class="mission" :content="$store.state.content.founding" />
        </div>
      </div>

      <div class="about-wrapper">
        <h2 id="what-is-robosub"><a href="#what-is-robosub" class="header-link">What is RoboSub?</a></h2>
        <MarkdownRenderer class="about-us" :content="$store.state.content.robosub" />
      </div>
    </section>

    <MovingDivider :bottom="true" :index="3"/>
  </div>
</template>

<script>
import MovingDivider from '@/components/MovingDivider.vue'
import InfiniteCarousel from '@/components/InfiniteCarousel.vue'
import MarkdownRenderer from '@/components/MarkdownRenderer.vue'

export default {
  name: "AboutView",
  components: {
    MovingDivider,
    InfiniteCarousel,
    MarkdownRenderer
  },
  computed: {
    galleryImages() {
      return this.$store.state.galleries?.team || [];
    }
  },
  methods: {
    focusVideo() {
      if (this.$refs.videoIframe) {
        this.$refs.videoIframe.focus();
      }
    }
  }
}
</script>

<style lang="scss">
@keyframes rise {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.wrapper {
  position: relative;
  background-color: var(--medium);

  #waves {
    transform: translateY(100%);
    animation: rise 2s 1s forwards ease-in-out;
    z-index: -1;
  }

  #about {
    color: var(--white);
    background-color: var(--medium);
    padding: var(--section-padding);
    padding-top: 4rem;
    padding-bottom: 3rem;
    font-size: 1rem;
    line-height: 1.35;
    text-align: left;

    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    gap: 2em;
    margin: auto;
    max-width: var(--max-width);

    .about-wrapper {
      .about-us {
        margin-top: 0.5em;
        line-height: 1.35;
      }
    }

    .section {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;
      gap: 3em;
      width: 100%;

      .video-container {
        flex: 1 1 auto;
        min-width: 0;
        display: flex;
        border-radius: var(--border-radius-md);
        outline: none;

        &:focus-visible {
          outline: 2px dashed var(--regular);
          outline-offset: 4px;
        }

        iframe {
          width: 100%;
          min-height: 280px;
          border: none;
          border-radius: var(--border-radius-md);
        }
      }

      .mission-wrapper {
        .mission {
          margin-top: 0.5em;
          max-width: 20em;
          line-height: 1.35;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  #about {
    padding: 3rem var(--section-padding-mobile, 6%) 2rem;
    font-size: 0.95rem;
    text-align: left;
    gap: 1.5rem;

    .about-wrapper {
      .about-us {
        line-height: 1.35;
      }
    }

    .section {
      gap: 1.5rem;

      .video-container {
        width: 100%;
        max-width: 100%;
        aspect-ratio: 16 / 9;
        margin: 0 auto;
        border-radius: var(--border-radius-md);

        iframe {
          width: 100%;
          height: 100%;
          aspect-ratio: 16 / 9;
          border-radius: var(--border-radius-md);
        }
      }

      .mission-wrapper {
        .mission {
          max-width: 100%;
          text-align: left;
          line-height: 1.35;
        }
      }
    }
  }
}
</style>